/* @flow */

import * as Yup from 'yup'

import WebshopTextWidget from './WebshopTextWidget'
import WebshopTextWidgetSettings from './WebshopTextWidgetSettings'

type WidgetSettings = {
  text: string,
}

const widget = {
  component: WebshopTextWidget,
  settings: WebshopTextWidgetSettings,

  available_children: [],
  label: 'Text',

  default_settings: ({
    text: '<p style="color: black;">Text</p>',
  }: WidgetSettings),

  default_style: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,

    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0,
  },

  settings_validation: Yup.object().shape({
    data: Yup.object().shape({}),
  }),
}

export default widget
